export class DataCatalogPipelineAddressPartPattern {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "selectionPattern",
            "baseName": "selectionPattern",
            "type": "string",
            "format": ""
        },
        {
            "name": "excludePattern",
            "baseName": "excludePattern",
            "type": "string",
            "format": ""
        },
        {
            "name": "merge",
            "baseName": "merge",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "mergedAs",
            "baseName": "mergedAs",
            "type": "string",
            "format": ""
        },
        {
            "name": "provenanceColumn",
            "baseName": "provenanceColumn",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DataCatalogPipelineAddressPartPattern.attributeTypeMap;
    }
    constructor() {
    }
}
